import { Component } from "react";
import {
    Dialog, DialogTitle, DialogContent,
    Stack, Typography, CircularProgress, IconButton, Chip
} from "@mui/material";
import { MdClose, MdOutlineClose } from "react-icons/md";
import BasicDataGrid from "./BasicDataGrid";
import { httpGet } from "../util/http";

export default class EstoqueInventarioDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            rows: [],
        };

        this.columns = [
            { field: 'codigo', headerName: 'Código', width: 110 },
            { field: 'derivacao', headerName: 'Derivação', width: 110 },
            { field: 'descricao', headerName: 'Descrição', flex: 1 },
            {
                field: 'tipo', headerName: 'Tipo', width: 100,
                renderCell: (params) => (
                    <Chip
                        size="small"
                        label={params.value === 'E' ? 'Entrada' : 'Saída'}
                        color={params.value === 'E' ? 'success' : 'error'}
                        variant="outlined"
                    />
                )
            },
            { field: 'qtdMov', headerName: 'Quantidade', width: 130, type: 'number' },
        ];
    }

    componentDidMount() {
        this.carregarEstoque();
    }

    carregarEstoque() {
        this.setState({ loading: true });
        httpGet('/statistics/inventario/' + this.props.inventarioId,
            movimentos => {
                this.setState({
                    rows: movimentos || [],
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false, rows: [] });
            },
        );
    }

    render() {
        return (
            <Dialog open={true} onClose={() => this.props.onClose()} maxWidth="md" fullWidth>
                <DialogTitle color="primary" fontSize={12}><b>Estoque do inventário</b></DialogTitle>
                <IconButton onClick={e => this.props.onClose(e)} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent dividers>
                    {this.state.loading ?
                        <Stack alignItems="center" p={3}><CircularProgress /></Stack> :
                        this.state.rows.length === 0 ?
                            <Typography variant="body2" color="text.secondary">
                                Nenhuma movimentação encontrada para este inventário.
                            </Typography> :
                            <Stack height={450}>
                                <BasicDataGrid
                                    props={{ loading: this.state.loading }}
                                    rows={this.state.rows}
                                    columns={this.columns}
                                />
                            </Stack>
                    }
                </DialogContent>
            </Dialog>
        );
    }
}